export const pt = {
  tag: "pt-BR",
  page: {
    select: {
      title: "Selecione sua loja:",
    },
    status: {
      onMaintence: "Loja em manutenção...",
    },
    store: {
      tip: {
        part1: "Precisando de ajuda? Entre em contato via ",
        partSocial: "Facebook",
        part2: " ou ",
        partSystem: "Suporte",
      },
      item: {
        only: "Apenas",
        days: "dia(s)",
        hours: "h",
        minutes: "min",
        seconds: "seg",
        availableUntil: "Disponível até",
        buy: "COMPRAR",
        gift: "Brinde(s):",
        bonus: "Conteúdo Bônus:",
      },
      historic: "Ver histórico",
    },
    payment: {
      confirmationQuestion:
        "Têm certeza que deseja comprar para a conta @Acc e para o servidor @Server?",
      packsQuestion: "Quantos pacotes deseja adquirir?",
      methodQuestion: "Selecione um meio de pagamento:",
      other: "Outro",
      note: "O custo final do pagamento pode mudar de acordo com o método escolhido. Para ver o custo final clique nos botões acima.",
      noMethods: "Nenhum método de pagamento disponível nesse momento. Por favor, entre em contato com o suporte para assistência.",
    },
    confirmation: {
      phone: "Número do celular",
      fullname: "Nome completo",
      cep: "CEP",
      cpf: "CPF",
      submit: "Enviar",
      error: {
        phone: "Telefone inválido",
        fullname: "Nome incompleto",
        invalidCep: "CEP inválido",
        incompleteCep: "CEP incompleto",
        invalidCpf: "CPF inválido",
        incompleteCpf: "CPF incompleto",
        submitMissingFields: "Erro ao enviar campos ausentes",
      },
    },
  },
  component: {
    header: {
      button: "Voltar",
    },
    steps: {
      step1: "Loja",
      step2: "Pacote",
      step3: "Pagamento",
      step4: "Processamento",
    },
    shop: {
      loading: "Carregando loja...",
      tabs: { evento: "EVENTO", loja: "LOJA", loki: "SEASON" },
      balance: "Saldo atual",
      history: "Histórico de compras",
      goToPayment: "IR PARA PAGAMENTO",
      selectPackage: "SELECIONE UM PACOTE",
      cart: {
        empty: "Carrinho vazio",
        items: "item(s) no carrinho",
        add: "Adicione itens para continuar.",
        total: "Total:",
        itemAdded: "Item adicionado",
        itemRemoved: "Item removido",
      },
    },
    loyaltyPath: {
      title: "Loyalty Path",
      description: "Ganhe pontos ao adquirir pacotes e resgate recompensas.",
      learnMore: "Saiba mais",
      learnMoreTooltip: "Para saber mais informações, acesse o link abaixo.",
      learnMoreTooltipLink: "Clique aqui para saber mais",
      weekly: "JORNADA SEMANAL",
      monthly: "JORNADA MENSAL",
      endsOn: "Termina em",
      totalPoints: "Total de pontos conquistados:",
      points: "pts",
      available: "Disponível",
      claim: "Resgatar",
      claimed: "Resgatado",
      inProgress: "Em progresso",
      period: "Período:",
      periodConnector: "a",
      accumulatedPoints: "Pontos Acumulados",
      currentPointsLabel: "Pontuação atual",
      projectedPointsLabel: "Pontuação prevista",
      faltam: "Faltam",
      missingPoints: "pontos para o próximo tesouro",
      requirement: "Requisito:",
      scrollHint: "Arraste para ver todos os tesouros →",
      blocked: "Bloqueado",
      claimAgain: "Resgatar novamente",
      claimedTimes: "Resgatado x{n}",
      timesClaimedLabel: "Vezes resgatado: {n}",
      repeatable: "Renovável",
      repeatableTitle: "Resgate ilimitado",
      repeatableHint: "Resgate sempre que atingir a meta novamente",
      repeatableCost: "Cada resgate consome {n} pts",
      balance: "Saldo disponível",
      consumed: "Consumido",
      carryoverReceived: "Pontos não utilizados na edição anterior",
      carryoverNextFull: "Pontos não utilizados serão transferidos para a próxima edição mensal.",
      carryoverNextPartial: "{pct}% dos pontos não utilizados serão transferidos para a próxima edição mensal.",
      itemTypes: {
        movel: "Móvel",
        imovel: "Imóvel",
        naoarmazenavel: "Não armazenável",
        trocaunica: "Troca única",
      },
      claimModal: {
        successTitle: "Sucesso!",
        successSingle: "Você resgatou {item}!",
        successMulti: "Você resgatou os itens acima!",
        errorTitle: "Atenção",
        close: "Fechar",
        errors: {
          notFound: "Recompensa não encontrada.",
          alreadyClaimed: "Esta recompensa já foi resgatada.",
          editionClosed: "A edição foi encerrada. Os pontos foram transferidos para a próxima edição.",
          accountBlocked: "Sua conta está bloqueada para esta ação.",
          insufficientPoints: "Não foi possível resgatar. Verifique se as metas anteriores foram resgatadas ou se você possui pontos suficientes.",
          unknown: "Ocorreu um erro inesperado. Se persistir, entre em contato com o suporte.",
        },
      },
    },
    packCard: {
      badge: "Pacote",
      preSale: "PRÉ-VENDA",
      bonusContent: "Conteúdo Bônus",
      packContent: "Conteúdo do Pacote",
      bonusContentTooltip: "Os itens do conteúdo bônus serão entregues sempre que um pacote for adquirido.",
      bonusContentTooltipLink: "Clique aqui para mais detalhes",
      guaranteedGift: "[+] Presente Garantido!",
      guaranteedGiftTooltip: "Os itens do presente garantido serão entregues exclusivamente para a primeira compra de cada pacote.",
      addToCart: "Adicionar",
    },
    eventItems: {
      bannerTitle: "BRINDE SEMANAL ATIVADO",
      bannerText: "Compre qualquer pacote disponível e receba um brinde exclusivo!",
      bannerTooltip: "O Traje e o Passe são itens de resgate único mensal. Uma vez resgatados, não serão mais enviados naquele mês.",
    },
    cart: {
      title: "Seu Carrinho",
      empty: "Seu carrinho está vazio.",
      summaryTitle: "Itens que você receberá",
      serverGlobal: "Global",
      serverSeason: "Season",
      summarySubtext: "Finalizando as compras desse carrinho, você receberá em sua conta os seguintes itens:",
      noGiftsEmpty: "Adicione pacotes de evento para ver os brindes aqui.",
      noGiftsPacks: "Os pacotes selecionados não possuem brindes adicionais.",
      continueShopping: "Continuar comprando",
      resumo: "TOTAL E PAGAMENTO",
      products: "produto",
      productsPlural: "produtos",
      finalize: "FINALIZAR COMPRA",
      finalizeDisabled: "ESCOLHA FORMA DE PAGAMENTO",
      paymentNote: "O custo final do pagamento pode mudar de acordo com o método escolhido. Para ver o custo final clique nos botões acima.",
      cardRestrictedNote: "Compra via cartão não está disponível para o seu perfil.",
      paymentHints: {
        "picpay-pix": "Tenha uma aprovação de compra mais rápida usando o Pix",
        "picpay": "Baixe o aplicativo do PicPay e compre em até 12x sem juros",
      },
    },
    loyaltyHistory: {
      title: "Loyalty Pass - Histórico",
      date: "Data",
      pack: "Pacote",
      pointsEarnedMonthly: "Pontos gerados no mês",
      pointsEarnedWeekly: "Pontos gerados na semana",
    },
    purchaseHistory: {
      title: "Histórico de Compras",
      date: "Data",
      pack: "Pacote",
      price: "Valor",
      qty: "Qtd",
      gateway: "Gateway",
      status: "Status",
      server: "Servidor",
      empty: "Nenhuma compra encontrada.",
      statusLabels: {
        waiting: "Aguardando",
        processing: "Processando",
        delivered: "Entregue",
      },
    },
  },
};
